function moremenu() {
    var t = $("#accessibleNav > li");
    t.slice(4, t.length).wrapAll('<li class="more_menu site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">'),
        jQuery(".more_menu").prepend('<a href="#" class="level-top topmega-menu-link">More</a>'),
        jQuery(".more_menu").mouseover(function () {
            jQuery(this).children("ul").addClass("shown-link"), jQuery("body").addClass("menu-open");
        }),
        jQuery(".more_menu").mouseout(function () {
            jQuery(this).children("ul").removeClass("shown-link"), jQuery("body").removeClass("menu-open");
        }),
        $("#accessibleNav").css("display", "block");
}
function footercolumn() {
    991 >= $(window).width()
        ? jQuery("#shopify-section-footer-model-3 .footer-column.links").insertBefore("#shopify-section-footer-model-3 .footer-column.contactus")
        : $(window).width() >= 992 && jQuery("#shopify-section-footer-model-3 .footer-column.links").insertAfter("#shopify-section-footer-model-3 .social-icons-list-main");
}
function height() {
    var t = $(".design_3 .product-block .product-img .image,.design_2 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img").height();
    $(".design_3 .product-block .product-img .extra-video,.design_2 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img").height(t),
        $(".design_3 .product-block .product-img .video,.design_2 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img").height(t),
        $(".design_3 .product-block .product-img .model,.design_2 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img").height(t);
}
function footerToggle() {
    992 > jQuery(window).width()
        ? (jQuery(".sidebar .collection_sidebar .sidebar-block").insertAfter(".filter-wrapper"),
          jQuery("#shopify-section-footer-model-2 .footer-column.links").insertAfter("#shopify-section-footer-model-2 .footer-logo-content"),
          jQuery(".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass("toggle"),
          jQuery(".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(":nth-child(2)").css("display", "none"),
          jQuery(".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(":nth-child(2)").css("display", "block"),
          jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click"),
          jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on("click", function () {
              jQuery(this).parent().toggleClass("active").children(":nth-child(2)").slideToggle("fast");
          }),
          jQuery(".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4").addClass("toggle"),
          jQuery(".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget ").children(":nth-child(2)").css("display", "none"),
          jQuery(".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active").children(":nth-child(2)").css("display", "block"),
          jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").unbind("click"),
          jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").on("click", function () {
              jQuery(this).parent().toggleClass("active").children(":nth-child(2)").slideToggle("fast");
          }))
        : (jQuery(".sidebar-block").prependTo(".collection_sidebar"),
          jQuery("#shopify-section-footer-model-2 .footer-column.links").insertBefore("#shopify-section-footer-model-2 .copyright"),
          jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind("click"),
          jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass("toggle"),
          jQuery(".sidebar .widget,.sidebar-block .widget").children(":nth-child(2)").css("display", "block"));
}
function splitStr(t, o) {
    return t.split(o);
}
function countDownIni(t) {
    $(t).each(function () {
        var t,
            o = $(this);
        o.attr("data-promoperiod") ? (t = new Date().getTime() + parseInt(o.attr("data-promoperiod"), 10)) : o.attr("data-countdown") && (t = o.attr("data-countdown")),
            Date.parse(t) - Date.parse(new Date()) > 0 &&
                ($(this).addClass("countdown-block"),
                o.countdown(t, function (t) {
                    o.html(
                        t.strftime(
                            '<span><span class="left-txt">Left</span><span class="mddle-txt">%D</span><span class="time-txt">Days</span></span><span><span class="mddle-txt">%H</span><span class="time-txt">Hrs</span></span><span><span class="mddle-txt">%M</span><span class="time-txt">Min</span></span><span><span class="second mddle-txt">%S</span><span class="time-txt">Sec</span></span>'
                        )
                    );
                }));
    });
}
function hb_animated_contents() {
    $(".hb-animate-element:in-viewport").each(function (t) {
        var o = $(this);
        o.hasClass("hb-in-viewport") ||
            setTimeout(function () {
                o.addClass("hb-in-viewport");
            }, 180 * t);
    });
}
function sidebarsticky() {
    1199 >= $(document).width()
        ? jQuery(".left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left").theiaStickySidebar({ additionalMarginBottom: 30, additionalMarginTop: 30 })
        : $(document).width() >= 1200 && jQuery(".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left").theiaStickySidebar({ additionalMarginBottom: 30, additionalMarginTop: 130 });
}
$(document).ready(function () {
    (function (t) {
        "use strict";
        t(document).ready(function () {
            var o = document.querySelector(".progress-wrap path"),
                s = o.getTotalLength();
            (o.style.transition = o.style.WebkitTransition = "none"),
                (o.style.strokeDasharray = s + " " + s),
                (o.style.strokeDashoffset = s),
                o.getBoundingClientRect(),
                (o.style.transition = o.style.WebkitTransition = "stroke-dashoffset 10ms linear");
            var i = function () {
                var i = t(window).scrollTop(),
                    a = t(document).height() - t(window).height();
                o.style.strokeDashoffset = s - (i * s) / a;
            };
            i(),
                t(window).scroll(i),
                jQuery(window).on("scroll", function () {
                    jQuery(this).scrollTop() > 50 ? jQuery(".progress-wrap").addClass("active-progress") : jQuery(".progress-wrap").removeClass("active-progress");
                }),
                jQuery(".progress-wrap").on("click", function (t) {
                    return t.preventDefault(), jQuery("html, body").animate({ scrollTop: 0 }, 550), !1;
                });
        });
    })(jQuery),
        jQuery(".nav-toggle").click(function (t) {
            jQuery(this).toggleClass("active"), t.stopPropagation(), jQuery(" #al-megamenu .al-mega_menu").slideToggle("2000"), jQuery("body").toggleClass("open-header");
        }),
        jQuery("#al-megamenu .al-mega_menu").on("click", function (t) {
            t.stopPropagation(), jQuery(this).removeClass("active");
        }),
        jQuery("#al-megamenu .al-mega_menu .al_mm_hassub").hover(
            function () {
                jQuery("body").addClass("menu_hover");
            },
            function () {
                jQuery("body").removeClass("menu_hover");
            }
        ),
        jQuery(".filter-toggle").on("click", function (t) {
            t.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".filter-toggle-wrap").slideToggle("is-visible");
        });
    var t = jQuery(this).find(".full_width .sorting_wrapper");
    jQuery(this).find(".filter-toggle").insertBefore(t),
        jQuery(".product-single__thumbs img").on("click", function () {
            var t = jQuery(this).attr("src");
            "" != t && jQuery(this).closest(".product-wrapper").find("img.grid-view-item__image").first().attr("src", t), jQuery(this).parent(".grid-item").addClass("open").siblings(".grid-item").removeClass("open");
        });
    var o = jQuery(".popup_overlay");
    function s(t) {
        var o = document.getElementById("popupVid").getElementsByTagName("iframe")[0].contentWindow;
        (func = "hide" == t ? "pauseVideo" : "playVideo"), o.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
    }
    jQuery("#popup_toggle").click(function () {
        jQuery("body").addClass("popup-toggle"), o.css("display", "block");
    }),
        o.click(function (t) {
            (e = t || window.event).target == this && (jQuery(o).css("display", "none"), jQuery("body").removeClass("popup-toggle"));
        }),
        jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").click(function () {
            o.css("display", "none"), jQuery("body").removeClass("popup-toggle");
        }),
        jQuery("#popup_toggle, .homeslider ul.slick-slider .slick-arrow").click(function () {
            o.css("visibility", "visible").css("opacity", "1");
        }),
        o.click(function (t) {
            (e = t || window.event).target == this && (jQuery(o).css("visibility", "hidden").css("opacity", "0"), s("hide"));
        }),
        jQuery(".popup_close").click(function () {
            o.css("visibility", "hidden").css("opacity", "0"), s("hide");
        }),
        jQuery(".shopify-payment-button .shopify-payment-button__button").prepend(jQuery("<i class='mdi mdi-cart-outline'></i>"));
    var i = $(window).width();
    $(".slider-content-main-wrap").css("width", i), $(".site-header").hasClass("header_transaparent") && $("body.template-index").addClass("header_transaparent");
    var a = jQuery(".product-single__thumbs .slick-active.slick-current").find(".product-single__thumb").data("id");
    jQuery(".product-lightbox-btn").hasClass(a) && jQuery(".product-lightbox-btn." + a).show(),
        jQuery(".filter-left").on("click", function (t) {
            t.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-left").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
        }),
        jQuery(".filter-right").on("click", function (t) {
            t.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-right").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
        }),
        jQuery(".off-canvas .sidebar_close").on("click", function (t) {
            t.preventDefault(),
                jQuery(".off-canvas.position-left").removeClass("is-open"),
                jQuery(".off-canvas.position-right").removeClass("is-open"),
                jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
        }),
        jQuery(".is-overlay-fixed").on("click", function (t) {
            t.preventDefault(),
                jQuery(".filter-left").trigger("click"),
                jQuery(".filter-right").trigger("click"),
                jQuery(".off-canvas.position-left").removeClass("is-open"),
                jQuery(".off-canvas.position-right").removeClass("is-open"),
                jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
        }),
        $(".product-360-button a").magnificPopup({
            type: "inline",
            mainClass: "mfp-fade",
            removalDelay: 160,
            disableOn: !1,
            preloader: !1,
            fixedContentPos: !1,
            callbacks: {
                open: function () {
                    $(window).resize();
                },
            },
        }),
        countDownIni(".flip-countdown,.js-flip-countdown"),
        $(".popup-video").magnificPopup({ disableOn: 300, type: "iframe", mainClass: "mfp-fade", removalDelay: 160, preloader: !1, fixedContentPos: !1 }),
        ($("a.product-lightbox-btn").length > 0 || $("a.product-video-popup").length > 0) &&
            $(".product-single__photos .gallery,.design_2 .product-img").magnificPopup({
                delegate: "a",
                type: "image",
                tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
                removalDelay: 300,
                closeOnContentClick: !0,
                gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
                image: { verticalFit: !1, tError: '<a href="%url%">The image #%curr%</a> could not be loaded.' },
                callbacks: {
                    beforeOpen: function () {
                        var t = $(".product-video-popup").attr("href");
                        if (t) {
                            this.st.mainClass = "has-product-video";
                            var o = $.magnificPopup.instance;
                            o.items.push({ src: t, type: "iframe" }), o.updateItemHTML();
                        }
                    },
                    open: function () {},
                },
        }),
        $(".design_3 .pro_img").magnificPopup({
            delegate: "a",
            type: "image",
            tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
            removalDelay: 300,
            closeOnContentClick: !0,
            gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
            image: { verticalFit: !1, tError: '<a href="%url%">The image #%curr%</a> could not be loaded.' },
            callbacks: {
                beforeOpen: function () {
                    var t = $(".product-video-popup").attr("href");
                    if (t) {
                        this.st.mainClass = "has-product-video";
                        var o = $.magnificPopup.instance;
                        o.items.push({ src: t, type: "iframe" }), o.updateItemHTML();
                    }
                },
                open: function () {},
            },
        }),
        $("body").on("click", ".product-lightbox-btn", function (t) {
            $(".product-wrapper-owlslider").find(".owl-item.active a").click(), t.preventDefault();
        }),
        $(".qtyplus").on("click", function (t) {
            t.preventDefault(), jQuery(this).parents(".qty-box-set").find(".quantity");
            var o = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val()),
                s = jQuery(".cart-update .quantity").data("item-id");
            console.log(s),
                isNaN(o)
                    ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
                    : jQuery(this)
                          .parents(".qty-box-set")
                          .find(".quantity")
                          .val(o + 1);
        }),
        $(".qtyminus").on("click", function (t) {
            t.preventDefault(), jQuery(this).parents(".qty-box-set").find(".quantity");
            var o = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val());
            !isNaN(o) && o > 1
                ? jQuery(this)
                      .parents(".qty-box-set")
                      .find(".quantity")
                      .val(o - 1)
                : jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
        }),
        $("#navToggle").on("click", function (t) {
            jQuery(this).next(".Site-navigation").slideToggle(500);
        }),
        $(".menu_toggle_wrap #navToggle").on("click", function (t) {
            jQuery(this).parent().next(".Site-navigation").slideToggle(500);
        }),
        $(".demo-heading").on("click", function (t) {
            t.preventDefault(), $("#shopify-section-demo-list").toggleClass("active");
        }),
        $(".demos-close-icon").on("click", function (t) {
            $("#shopify-section-demo-list").removeClass("active");
        }),
        jQuery(".site-header__search.search-full .serach_icon").on("click", function (t) {
            t.preventDefault(),
                jQuery(this).toggleClass("active"),
                jQuery("body").toggleClass("search_full_active"),
                jQuery(".search-full-screen").slideToggle("slow"),
                jQuery(".search-bar input.input-group-field").focus(),
                jQuery(".full-search-wrapper").addClass("search-overlap"),
                jQuery(".myaccount  .dropdown-toggle").removeClass("open"),
                jQuery(".myaccount  .customer_account").slideUp("fast"),
                jQuery(".site-header .site-header_cart_link").removeClass("active"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("body").toggleClass("search_toggle"),
                jQuery("body").removeClass("account-toggle"),
                jQuery("body").removeClass("cart_toggle");
        }),
        jQuery(".site-header__search.search-full .close-search").on("click", function () {
            jQuery(".site-header__search.search-full .serach_icon").removeClass("active"),
                jQuery(".full-search-wrapper").removeClass("search-overlap"),
                jQuery(".full-search-wrapper").removeClass("search-overlap"),
                jQuery("body").removeClass("search_full_active"),
                jQuery("body").removeClass("search_toggle"),
                jQuery(".search-full-screen").slideUp("slow");
        }),
        jQuery(".myaccount .dropdown-toggle").on("click", function (t) {
            t.preventDefault(),
                jQuery(".header_1 .customer_account").slideToggle("fast"),
                jQuery(".myaccount").toggleClass("open"),
                jQuery("body").toggleClass("account-toggle"),
                992 > jQuery(window).width() && jQuery(".header_1 .search_wrapper").slideUp("fast"),
                jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass("active"),
                jQuery("body").removeClass("search_full_active"),
                jQuery("body").removeClass("currency-open"),
                jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
                jQuery("body").removeClass("language-open"),
                jQuery(".header_language .disclosure__toggle").removeClass("active"),
                jQuery(".header_currency .currency_wrapper.dropdown-toggle").removeClass("active"),
                jQuery(".header_language .disclosure-list").slideUp("fast"),
                jQuery(".site-header .site-header_cart_link").removeClass("active"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast"),
                jQuery("body").removeClass("search_toggle"),
                jQuery("body").removeClass("cart_toggle");
        }),
        jQuery(".myaccount .dropdown-toggle").on("click", function (t) {
            t.preventDefault(),
                jQuery(".header_2 .customer_account").slideToggle("fast"),
                jQuery(".myaccount").toggleClass("open"),
                jQuery("body").toggleClass("account-toggle"),
                992 > jQuery(window).width() && jQuery(".header_2 .search_wrapper").slideUp("fast"),
                jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass("active"),
                jQuery("body").removeClass("search_full_active"),
                jQuery("body").removeClass("currency-open"),
                jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
                jQuery("body").removeClass("language-open"),
                jQuery(".header_language .disclosure__toggle").removeClass("active"),
                jQuery(".header_currency .currency_wrapper.dropdown-toggle").removeClass("active"),
                jQuery(".header_language .disclosure-list").slideUp("fast"),
                jQuery(".site-header .site-header_cart_link").removeClass("active"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast"),
                jQuery("body").removeClass("search_toggle"),
                jQuery("body").removeClass("cart_toggle");
        }),
        jQuery(".myaccount .dropdown-toggle").on("click", function (t) {
            t.preventDefault(),
                jQuery(".header_3 .customer_account").slideToggle("fast"),
                jQuery(".myaccount").toggleClass("open"),
                jQuery("body").toggleClass("account-toggle"),
                992 > jQuery(window).width() && jQuery(".header_3 .search_wrapper").slideUp("fast"),
                jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass("active"),
                jQuery("body").removeClass("search_full_active"),
                jQuery("body").removeClass("currency-open"),
                jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
                jQuery("body").removeClass("language-open"),
                jQuery(".header_language .disclosure__toggle").removeClass("active"),
                jQuery(".header_currency .currency_wrapper.dropdown-toggle").removeClass("active"),
                jQuery(".header_language .disclosure-list").slideUp("fast"),
                jQuery(".site-header .site-header_cart_link").removeClass("active"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast"),
                jQuery("body").removeClass("search_toggle"),
                jQuery("body").removeClass("cart_toggle");
        }),
        jQuery(".header_language .disclosure__toggle").on("click", function (t) {
            t.preventDefault(),
                jQuery(".customer_account").stop(),
                jQuery("body").toggleClass("language-open"),
                jQuery("body").removeClass("currency-open"),
                jQuery("body").removeClass("account-toggle"),
                jQuery("body").removeClass("cart_active"),
                jQuery(".myaccount").removeClass("open"),
                jQuery(".currency_wrapper").removeClass("active"),
                jQuery(".disclosure-list").slideToggle("fast"),
                jQuery(this).toggleClass("active"),
                jQuery(".customer_account").slideUp("fast"),
                jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast");
        }),
        $(".header_currency .currency_wrapper.dropdown-toggle").on("click", function (t) {
            t.preventDefault(),
                jQuery(".customer_account").stop(),
                jQuery("body").toggleClass("currency-open"),
                jQuery("body").removeClass("language-open"),
                jQuery("body").removeClass("account-toggle"),
                jQuery("body").removeClass("cart_active"),
                jQuery(".myaccount").removeClass("open"),
                jQuery(".disclosure__toggle").removeClass("active"),
                jQuery(".currencies.flag-dropdown-menu").slideToggle("fast"),
                $(this).toggleClass("active"),
                jQuery(".customer_account").slideUp("fast"),
                jQuery(".header_language .disclosure-list").slideUp("fast"),
                jQuery("#slidedown-cart").slideUp("fast"),
                jQuery("#Sticky-slidedown-cart").slideUp("fast");
        }),
        $(".feature-collection .product-grid").owlCarousel({
            items: 4,
            dots: !1,
            loop: !1,
            nav: !0,
            rewind: !1,
            autoplay: !1,
            responsive: { 100: { items: 1, nav: !1, dots: !0 }, 480: { items: 2, nav: !1, dots: !0 }, 600: { items: 3 }, 992: { items: 4 }, 1300: { items: 4 } },
        });

  
    var n = $("body:not(.rtl) #brands_list_slider"),
        r = $("body.rtl #brands_list_slider");
    n.owlCarousel({
        items: 6,
        dots: false,
        rewind: !0,
        autoplay: true,
        rtl:false,
        autoplayHoverPause: true,
        autoplayTimeout:2000,
        nav: false,
        loop:true,
        responsive: { 100: { items: 2, nav: !1, dots: !0 }, 320: { items: 2, nav: !1, dots: !0 }, 544: { items: 3, nav: !1 }, 992: { items: 4 }, 1200: { items: 6 } },
    }),
        r.owlCarousel({ 
          items: 6,
          dots: false,
          rewind: !0,
          rtl:false,
          autoplay: true,
          autoplayHoverPause: true,
          autoplayTimeout:2000,
          nav: false,
          loop: true,
          responsive: { 100: { items: 2 }, 320: { items: 2 }, 544: { items: 3 }, 992: { items: 4 }, 1200: { items: 6 } } }),
        $(".brands_next").click(function () {
            n.trigger("owl.next");
        }),
        $(".brands_prev").click(function () {
            n.trigger("owl.prev");
        }),
        $(".brands_next").click(function () {
            r.trigger("owl.next");
        }),
        $(".brands_prev").click(function () {
            r.trigger("owl.prev");
        }),
        $("#cmsgallery .image-content").owlCarousel({ items: 6, dots: !1, loop: !1, nav: !0, rewind: !1, autoplay: !1, responsive: { 100: { items: 1 }, 315: { items: 2 }, 600: { items: 3 }, 992: { items: 4 }, 1300: { items: 6 } } }),
        $("body:not(.rtl) .ttcms-banner .ttbanner-wrap").owlCarousel({ items: 2, nav: !1, dots: !1, loop: !1, autoplay: !0, rtl: !1, responsive: { 992: { items: 2 }, 600: { items: 2 }, 100: { items: 1 } } }),
        $("body.rtl .ttcms-banner .ttbanner-wrap").owlCarousel({ items: 2, nav: !1, dots: !1, loop: !1, autoplay: !0, rtl: !0, responsive: { 992: { items: 2 }, 600: { items: 2 }, 100: { items: 1 } } });
    var _ = $("body:not(.rtl) .ttcmsoffer-block .ttcmsoffer-content");
    _.owlCarousel({ items: 1, dots: !1, loop: !0, nav: !0, rewind: !0, autoplay: !0, autoplayHoverPause: !0, responsive: { 100: { items: 1 }, 1300: { items: 1 } } });
    var _ = $("body.rtl .ttcmsoffer-block .ttcmsoffer-content");
    _.owlCarousel({ items: 1, dots: !1, loop: !0, nav: !0, rtl: !0, rewind: !0, autoplay: !0, autoplayHoverPause: !0, responsive: { 100: { items: 1 }, 1300: { items: 1 } } }),
        $(".product-thumb .slider-nav").owlCarousel({
            items: 1,
            dots: !1,
            loop: !0,
            nav: !0,
            rewind: !0,
            autoplay: !0,
            autoplayHoverPause: !0,
            responsive: { 100: { items: 1 }, 481: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1300: { items: 1 } },
        }),
        $("body .about-services .block_content").owlCarousel({ items: 3, nav: !1, dots: !0, loop: !1, autoplay: !1, rewindNav: !0, responsive: { 1200: { items: 3 }, 768: { items: 3 }, 481: { items: 2 }, 100: { items: 1 } } }),
        $("body:not(.rtl) #al-megamenu .list_product_menu_content").owlCarousel({
            items: 3,
            nav: !1,
            autoPlay: !0,
            autoplaySpeed: 1e3,
            stopOnHover: !1,
            loop: !1,
            dots: !0,
            responsive: { 768: { items: 3 }, 360: { items: 2 }, 100: { items: 1 } },
        }),
        $("body.rtl #al-megamenu .list_product_menu_content").owlCarousel({
            items: 3,
            nav: !0,
            autoPlay: !0,
            autoplaySpeed: 1e3,
            rtl: !0,
            stopOnHover: !1,
            loop: !1,
            dots: !0,
            responsive: { 768: { items: 3 }, 360: { items: 2 }, 100: { items: 1 } },
        }),
        $(".full_gallery_slider.owl-carousel").on("changed.owl.carousel", function (e) {
            var t = e.target,
                o = e.item.count,
                s = e.relatedTarget.relative(e.item.index) + 1;
            $(t)
                .parent()
                .find(".num")
                .html(s + "/" + o);
        }),
        $("body:not(.rtl) .full_gallery_slider.owl-carousel").owlCarousel({
            loop: !0,
            startPosition: 0,
            center: !0,
            dots: !0,
            items: 1,
            lazyLoad: !0,
            nav: !1,
            responsive: { 100: { items: 1 }, 767: { items: 1 }, 991: { items: 3 }, 1199: { items: 3 }, 1299: { items: 3 } },
        }),
        $("body.rtl .full_gallery_slider.owl-carousel").owlCarousel({
            loop: !0,
            startPosition: 0,
            center: !0,
            dots: !0,
            items: 3,
            rtl: !0,
            lazyLoad: !0,
            nav: !1,
            responsive: { 100: { items: 1 }, 767: { items: 1 }, 991: { items: 3 }, 1199: { items: 3 }, 1299: { items: 3 } },
        }),
      
        $(".product-img.full_gallery_slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: !1,
            dots: !0,
            infinite: !0,
            centerMode: !0,
            prevArrow:
                '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
        }),
        $("body:not(.rtl) .tttestimonial-wrap .testimonials_wrap").owlCarousel({
            items: 1,
            nav: !0,
            navText: ["<i class='mdi-chevron-left mdi'></i>", "<i class='mdi-chevron-right mdi'></i>"],
            dots: !1,
            loop: !1,
            autoplay: !1,
            autoplayHoverPause: !0,
            responsive: { 1279: { items: 1 }, 1250: { items: 1 }, 600: { items: 1 } },
        }),
        $("body.rtl .tttestimonial-wrap .testimonials_wrap").owlCarousel({
            items: 1,
            nav: !0,
            navText: ["<i class='mdi-chevron-left mdi'></i>", "<i class='mdi-chevron-right mdi'></i>"],
            dots: !1,
            loop: !1,
            autoplay: !1,
            autoplayHoverPause: !0,
            responsive: { 1279: { items: 1 }, 1250: { items: 1 }, 600: { items: 1 } },
        }),
        $(".category-feature .owl-item").hover(function () {
            $(".category-feature .owl-item.center").addClass("changeStyle");
        }),
        $(".category-feature .owl-item").mouseleave(function () {
            $(".category-feature .owl-item.center").removeClass("changeStyle");
        }),
        $("body:not(.rtl) .widget_top_rated_products .top-products").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 3,
            arrows: !0,
            dots: !1,
            infinite: !1,
            appendArrows: $(".slick-nav"),
            prevArrow:
                '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }),
        $("body.rtl .widget_top_rated_products .top-products").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 3,
            arrows: !0,
            dots: !1,
            infinite: !1,
            prevArrow:
                '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }),
        $(".testimonial-section").owlCarousel({ 
          items: 1,
          loop: !0, 
          dots: !0, 
          nav: !0,
          autoplay: !0,
          responsiveClass: !0,
          autoplayHoverPause: !1, 
          lazyLoad: !0, 
          smartSpeed: 1e3, 
          autoplayTimeout: 3e3, 
          responsive: { 100: { items: 1,dots: !0, }, 576: { items: 1,dots: !0, }, 991: { items: 1 }, 1199: { items: 1 }, 1299: { items: 1 } },
        }),
        $(".design_2_slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !0,
            dots: !1,
            infinite: !1,
            prevArrow:
                '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
        }),

        jQuery(".spr-summary-actions-newreview").on("click", function (t) {
            t.preventDefault(), jQuery(".spr-content").slideToggle("slow");
        }),
        $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js").click(function () {
            $(this).addClass("loading"),
                setTimeout(function () {
                    $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js").removeClass("loading");
                }, 2e3);
        });
    var d = window.pageYOffset;
    window.onscroll = function () {
        var t = window.pageYOffset;
        d > t ? (document.getElementById("header-sticky").style.top = "0") : (document.getElementById("header-sticky").style.top = "-160px"), (d = t);
    };
}),
    jQuery(document).ready(function () {
        moremenu();
    }),
    jQuery(window).scroll(function () {
        jQuery(document).height() > jQuery(window).height() && (jQuery(window).scrollTop() > 100 ? jQuery("#GotoTop").fadeIn() : jQuery("#GotoTop").fadeOut());
    }),
    jQuery(function () {
        var t = jQuery(".header_style_6 #al-megamenu .al_menus_ul >li").length / 2,
            t = Math.floor(t);
        jQuery(".header_style_6 #al-megamenu .al_menus_ul >li:lt(" + t + ")").addClass("left-link"),
            jQuery(".header_style_6 #al-megamenu .al_menus_ul >li:not('.left-link')").addClass("right-link"),
            jQuery(".header_style_6 #al-megamenu .al_menus_ul >li.left-link").wrapAll('<div class="menu-left"></div>'),
            jQuery(".header_style_6 #al-megamenu .al_menus_ul >li.right-link").wrapAll('<div class="menu-right"></div>');
    }),
    jQuery(document).ready(function () {
        footercolumn();
    }),
    jQuery(window).resize(function () {
        footercolumn();
    }),
    jQuery(document).ready(function () {
          jQuery(".product-write-review").on("click", function (t) {
              t.preventDefault(), $("a[href='#tab-2']").trigger("click"), jQuery("html, body").animate({ scrollTop: jQuery(".product_tab_wrapper").offset().top - 150 }, 1e3);
          });
    }),
    jQuery(window).resize(function () {
        var t = $(window).width();
        $(".slider-content-main-wrap").css("width", t);
    }),
    $(document).ready(function () {
        height();
    }),
    $(window).resize(function () {
        height();
    }),
    $(window).scroll(function () {
        height();
    }),
    jQuery(document).ready(function () {
        footerToggle();
    }),
    jQuery(window).resize(function () {
        footerToggle();
    }),
    $(window).scroll(function () {
        hb_animated_contents();
    }),
    $(window).on("load", function () {
        hb_animated_contents();
    }),
    jQuery(document).ready(function () {
        sidebarsticky();
    }),
    jQuery(window).resize(function () {
        sidebarsticky();
    }),
    jQuery(function () {
        var t = function (t, o) {
            (this.el = t || {}),
                (this.multiple = o || !1),
                $("ul.al_menus_ul1 > li.al_mm_hassub").addClass("active"),
                this.el.find("li.al_mm_hassub .mobile-nav__sublist-trigger").on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
        };
        (t.prototype.dropdown = function (t) {
            t.preventDefault();
            var o = t.data.el;
            ($next = ($this = $(this)).next()).slideToggle(), $this.parent().toggleClass("open"), t.data.multiple || o.find("li.al_mm_hassub .al_sub_menu_wrap").not($next).slideUp().parent().removeClass("open");
        }),
            new t($(".al_menus_ul1"), !1);
    }),
    $(function () {
        if (!$("body").hasClass("fullnav-open")) {
            var t = function (t, o) {
                (this.el = t || {}), (this.multiple = o || !1), this.el.find("li.al_mm_hassub .mobile-nav__sublist-trigger").on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
            };
            (t.prototype.dropdown = function (t) {
                var o = t.data.el;
                ($next = ($this = $(this)).next()).slideToggle(), $this.parent().toggleClass("open"), t.data.multiple || o.find("li.al_mm_hassub .al_sub_menu_wrap").not($next).slideUp().parent().removeClass("open");
            }),
                new t($(".al_menus_ul"), !1);
        }
    }),
    $(function () {
        var t = function (t, o) {
            (this.el = t || {}), (this.multiple = o || !1), this.el.find(".toggle").on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
        };
        (t.prototype.dropdown = function (t) {
            var o = t.data.el;
            ($next = ($this = $(this)).next()).slideToggle(), $this.parent().toggleClass("active"), t.data.multiple || o.find(".inline-list").not($next).slideUp().parent().removeClass("active");
        }),
            new t($(".footer-column"), !1);
    });
